import { render } from "./discharge.vue?vue&type=template&id=18ca583f&ts=true"
import script from "./discharge.vue?vue&type=script&lang=ts"
export * from "./discharge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__